import type RootStore from "stores/RootStore";
import { RouteType } from "types/RouteType";
import type ContractsStore from "./ContractsStore";
import { ALL_CONTRACTS } from "./ContractsStore";

const storeOf = (rootStore: RootStore) =>
  (rootStore as unknown as { contractsViewStore?: ContractsStore }).contractsViewStore;

/**
 * Clients → Contracts & renewals: every client's contracts, the renewals,
 * ends and notice days coming up (Blake's contracts tracker in HQ, #3075 /
 * #2663). Any staff member reads it — dates are what account managers act on —
 * but values only reach administrators and finance (the API takes them off).
 *
 * A literal path: registered BEFORE ClientDetail's `/clients/:id`.
 */
const contractsRoute: RouteType[] = [
  {
    name: "ClientContracts",
    path: "/clients/contracts",
    layout: "/app",
    viewportCard: {
      header: {
        enableBackButton: true,
        title: "Contracts & renewals",
        enableRefreshButton: true,
        component: () => import("./Contracts.Header"),
      },
      body: { component: () => import("./Contracts.Body") },
    },
    group: "Clients",
    searchAliases: ["contracts", "renewals", "renewal dates", "notice", "agreements", "msa"],
    requiresAuth: true,
    requiresPermission: false,
    onEnter: ({ rootStore }) => {
      void storeOf(rootStore)?.initialize(ALL_CONTRACTS);
    },
    onExit: ({ rootStore }) => {
      storeOf(rootStore)?.reset();
    },
  },
];

export default contractsRoute;
